// extracted by mini-css-extract-plugin
var _1 = "title-Yyrr5";
export { _1 as "title" }
